import FormWithControls from 'app/shared-components/FormWithControls'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import useEnumValues from 'app/hooks/useEnumValues'
import StatusHandler from 'app/shared-components/StatusHandler'

import request from 'app/requests/Opportunity/Opportunity.requests'
import useGetOpportunityById from 'app/requests/Opportunity/hooks/useGetOpportunityById'

import {
    WithId,
} from 'app/types/common.types'
import getContainerInformationFields from './OpportunitiesContainerInformation.fields'
import useStyles from './OpportunitiesContainerInformation.style'

const OpportunitiesContainerInformation = ({
    id,
}: Readonly<WithId<number>>) => {
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetOpportunityById(id)

    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()

    const fields = getContainerInformationFields({
        getAllowedValues,
    })
    const fieldsWithClasses = useFieldsWithClassName([fields], classes)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                onSuccess={invalidate}
                value={data}
                name={request.domainName}
                fields={fieldsWithClasses}
                onCancel={invalidate}
                requestParams={request.UpdateContainerInformation({
                    opportunityId: data?.id,
                })}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                exists
            />
        </StatusHandler>
    )
}

export default OpportunitiesContainerInformation
